export default __webpack_public_path__ + "media/images/gallery/31-5ad5ace696557f51064142024fc6cc7e.jpg";